import { useMutation, useQueryClient } from "@tanstack/react-query";

import { dashboardService } from "../../../services/dashboardService";

export const useDeleteDashboard = () => {
  const qc = useQueryClient();

  return useMutation({
    mutationFn: async ({ dashboardId }: { dashboardId: string }) => {
      const deletedId = await dashboardService.delete(dashboardId);
      return { deletedId, dashboardId };
    },
    onSuccess: ({ dashboardId }) => {
      qc.invalidateQueries({ queryKey: ["dashboard", dashboardId] });
      qc.invalidateQueries({ queryKey: ["dashboards"] });
    },
  });
};
